import React from 'react';
import Link from 'next/link';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import Button from '@material-ui/core/Button';
import { ArrowLeft, Question } from 'phosphor-react';

import * as types from '../../../actions/actionTypes';
import styles from '../../../styles/sass/pages/SignUpNew.module.scss';

export interface HeaderSignupProps {
  dispatch: any;
  goBack: Function;
}

export const HeaderSignup: React.FC<HeaderSignupProps> = ({
  dispatch,
  goBack,
}) => {
  //Open Help Dialogs
  const openHelpDialog = () => {
    dispatch({
      type: types.OpenHelpDialog,
    });
  };

  return (
    <div className={styles.signupHeader}>
      <Button
        style={{ backgroundColor: 'transparent' }}
        className={styles.backButton}
        onClick={() => goBack()}
        disableRipple
      >
        <ArrowLeft size={24} color="#2C5853" weight="bold" />
        <span className={styles.back}>Back</span>
      </Button>
      <Link href="/dashboard">
        <a aria-label="Torii Homepage" className={styles.logo} />
      </Link>
      <Button
        style={{ backgroundColor: 'transparent' }}
        className={styles.helpButton}
        onClick={openHelpDialog}
        disableRipple
      >
        <Question size={24} color="#2C5853" weight="bold" />
        <span className={styles.help}>Help</span>
      </Button>
    </div>
  );
};

const mapStateToProps = (state: any) => ({});

const mapDispatchToProps = (dispatch: any) => ({
  dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderSignup);
